import { RedirectKeepUTM } from "../shared/components/RedirectKeepUTM";
import { buildBreadcrumbNavigationConfig } from "../shared/helpers/buildBreadcrumbNavigationConfig";

const financialProfileContentPath = "/financial-profile";

export const financialProfileContentPageNav = buildBreadcrumbNavigationConfig(
  "Financial Profile",
  financialProfileContentPath
);

export const routes = [
  {
    path: financialProfileContentPath,
    Component: () => <RedirectKeepUTM to="/" />,
    navigation: [financialProfileContentPageNav],
    exact: true,
    isPrivate: true,
  },
];
